import createReactComponent from '../createReactComponent';
export default createReactComponent('letter-i', 'LetterI', [["path",{"d":"M9 7h3.125m0 0h3.125m-3.125 0v10m3.125 0h-3.125m0 0H9","key":"svg-0"}]]);